import React from "react";
import { ToastContainer } from "./style";
import ReduxToastr from "react-redux-toastr";

export const Toast = () => {
  return (
    <ToastContainer>
      <ReduxToastr
        newestOnTop={false}
        preventDuplicates
        position="bottom-left"
        getState={state => state.toastr} // This is the default
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        closeOnToastrClick
      />
    </ToastContainer>
  );
};
